// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"x2-z","displaySixCardTiles":"y2-z"};